import React from 'react';
import { Box } from '@material-ui/core';
import 'react-multi-carousel/lib/styles.css';
import ChapterCarousel from './chapterCarousel';
import CoordinatorCarousel from './coordinatorCarousel';

const ItemCarousel = ({ post, cards }) => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 2.5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1.5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1.5,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1.5,
    },
  };

  const SwitchStreamType = ({ post, cards, responsive }) => {
    switch (post.streamType) {
      case 'LeaderboardCarouselStream':
      case 'CoordinatorCarouselStream':
      case 'BadgeWinnerCarouselStream':
        return <CoordinatorCarousel post={post} cards={cards} />;
      case 'WelcomeBLTVideoStream':
        return (
          <ChapterCarousel post={post} cards={cards} responsive={responsive} />
        );
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      {post && (
        <SwitchStreamType post={post} cards={cards} responsive={responsive} />
      )}
      <Box mb={2} />
    </React.Fragment>
  );
};

export default ItemCarousel;
